import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Container from '@material-ui/core/Container';
import Dialog from '@material-ui/core/Dialog';
import PlayCircleFilledIcon from '@material-ui/icons/PlayCircleFilled';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import bannerImage from 'assets/login/banner.jpg';
import logoImg from 'assets/logo-bg-white.svg';
import SignIn from './SignIn';
import { IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    display: 'flex',
    height: '100vh',
  },
  logo: {
    padding: theme.spacing(3),
    paddingLeft: theme.spacing(9)
  },
  banner: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  btnLabelBold: {
    fontWeight: 700,
  },
  cover: {
    backgroundImage: `url(${bannerImage})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.primary.dark,
  },
}));

const RegisterLogIn = () => {
  const classes = useStyles();
  const [showModal, setShowModal] = useState(false);
  return (
    <div className={classes.root}>
      <Grid container>
        <Grid md={5} xs={12} sm={6}>
          <div className={classes.logo}>
            <img src={logoImg} />
          </div>
          <Box textAlign="center" marginTop={4}>
            <Typography gutterBottom variant="h3">
              Hey, welcome back!
            </Typography>
            <Button
              size="large"
              startIcon={<PlayCircleFilledIcon />}
              variant="text"
              color="primary"
              onClick={() => setShowModal(true)}
              classes={{
                label: classes.btnLabelBold,
              }}
            >
              Watch Login Video
            </Button>
            <SignIn />
          </Box>
        </Grid>
        <Grid md={7} xs={12} sm={6} className={classes.cover}></Grid>
      </Grid>
      {showModal && (
        <Dialog
          open
          fullWidth
          maxWidth={'lg'}
          onBackdropClick={() => setShowModal(false)}
        >
          <div className="video-wrapper">
            <video
              autoPlay
              width="100%"
              height="auto"
              controls
              src="https://weadmit-static.s3.us-east-2.amazonaws.com/LogintoWeAdmit.mp4"
            />
            <IconButton
              aria-label="close"
              className={classes.closeButton}
              onClick={() => setShowModal(false)}
            >
              <CloseIcon />
            </IconButton>
          </div>
          <Box
            textAlign="center"
            paddingTop={3}
            paddingBottom={3}
            onClick={() => setShowModal(false)}
          >
            <Button variant="contained" color="primary">
              Close
            </Button>
          </Box>
        </Dialog>
      )}
    </div>
  );
};

export default RegisterLogIn;
